import AppProvider from "./Provider";

function APP(props) {
  const { children } = props;
  return <AppProvider>{children}</AppProvider>;
}

export default APP;
